<template>
  <div class="VB_Toolbar">
    <div class="VB_Toolbar_ToolArea VB_Toolbar_ToolArea--title">
      <div class="VB_Toolbar_ToolArea_Tool VB_Toolbar_ToolArea_Tool--title">
        {{ $store.getters.pageTitle }}
      </div>
    </div>
    <div class="VB_Toolbar_ToolArea VB_Toolbar_ToolArea--pages">
      <div
        v-if="$store.getters.pages"
        class="VB_Toolbar_ToolArea_Tool VB_Toolbar_ToolArea_Tool--pages"
      >
        1 / {{ $store.getters.pages }}
      </div>
    </div>
    <div class="VB_Toolbar_ToolArea VB_Toolbar_ToolArea--download">
      <a
        class="VB_Toolbar_ToolArea_Tool VB_Toolbar_ToolArea_Tool--download"
        href=""
        @click.prevent="print"
        title="Print Brochure"
      >
        <Icon icon="print" />
      </a>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faDownload } from "@fortawesome/free-solid-svg-icons/faDownload";
import { faPrint } from "@fortawesome/free-solid-svg-icons/faPrint";
import { FontAwesomeIcon as Icon } from "@fortawesome/vue-fontawesome";

library.add(faDownload, faPrint);

export default {
  name: "ViewmedicaBrochureToolbar",

  components: {
    Icon,
  },

  methods: {
    print() {
      if (this.demo) {
        if (this.$route.params.client === "68") {
          window.alert(
            this.$t("preview") ||
              "Preview Only. Print your brochures in your On-Demand player. Not included with VMcast."
          );
        } else {
          window.alert(
            this.$t("inactive") ||
              "Your account is not active. Please activate your account in order to enable printing."
          );
        }
        return;
      }

      window.print();
    },
  },

  computed: {
    demo() {
      return this.$store.getters.demo;
    },
  },
};
</script>

<style lang="scss">
.VB_Toolbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  background: rgb(51, 54, 57);
  display: grid;
  grid-template-columns: 40% auto 40%;
  box-shadow: 0px 0px 6px #2a2a2a;
  z-index: 2;

  @media only screen and (max-width: 420px) {
    grid-template-columns: calc(100% - 62px) 62px;
  }

  &_ToolArea {
    line-height: 50px;
    padding: 0 10px;

    &--title {
      text-align: left;
      box-sizing: border-box;
    }

    &--download {
      box-sizing: border-box;
      text-align: right;

      a {
        display: inline-block;
      }

      svg {
        vertical-align: middle;
        height: 1.15rem !important;
        width: 1.15rem !important;
      }
    }

    &--pages {
      text-align: center;
      box-sizing: border-box;

      @media only screen and (max-width: 420px) {
        display: none;
      }
    }

    &_Tool {
      padding: 0 15px;
      cursor: pointer;
      color: rgba(255, 255, 255, 0.8);
      transition: color 0.25s ease-in-out;
      text-overflow: ellipsis;
      white-space: nowrap;

      &--title {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      &:hover {
        color: rgba(255, 255, 255, 0.9);
        transition: color 0.25s ease-in-out;
      }
    }
  }

  @media print {
    display: none;
  }
}
</style>
